'use strict';

var processInclude = require('./util');

$(document).ready(function () {
    processInclude(require('./giftCertificate/giftCertificate'));

    //### START CUSTOM ADYEN ALPENITE ###
    processInclude(require('int_custom_adyen/adyen/express/product/expressPayments'));
    // ### END CUSTOM ADYEN ALPENITE ###
});
